import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { CSSTransitionGroup } from 'react-transition-group';

import { actions } from '../actions/actions';
import { actions as filterActions } from '../actions/filterActions';
import { actions as pageActions } from '../actions/pageActions';
import MonthPicker from './MonthPicker/index';
import TimeOfDayPicker from './TimeOfDayPicker/index';
import Calendar from './Calendar/index';
import styles from './datePicker.module.css';
import DayPicker from 'react-day-picker';

class DatePicker extends Component {
  static propTypes = {
    selectedDate: PropTypes.instanceOf(moment).isRequired,
    maxDays: PropTypes.number.isRequired,
    selectDay: PropTypes.func.isRequired,
    currentFilter: PropTypes.string.isRequired,
    practiceUrlName: PropTypes.string.isRequired,
    hasMorningAppointments: PropTypes.bool.isRequired,
    hasAfternoonAppointments: PropTypes.bool.isRequired,
    hasEveningAppointments: PropTypes.bool.isRequired,
    filterMorning: PropTypes.func.isRequired,
    filterAfternoon: PropTypes.func.isRequired,
    filterEvening: PropTypes.func.isRequired,
    setDateTimePickerIsShowing: PropTypes.func.isRequired,
    dateTimePickerIsShowing: PropTypes.bool.isRequired,
    services: PropTypes.arrayOf(PropTypes.object),
    serviceSelected: PropTypes.func.isRequired,
    locations: PropTypes.arrayOf(PropTypes.object),
    locationSelected: PropTypes.func.isRequired,
    selectedService: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.datepicker = React.createRef();
  }
  state = {
    currentMonth: moment(),
  };
  componentDidMount() {
    this.onClick(moment());
  }
  onClick = date => {
    return this.props.selectDay(date.toDate());
  };
  onMonthChange = monthIndex => {
    const newMonth = moment().add(monthIndex, 'months');
    if (newMonth.month() !== this.state.currentMonth.month()) {
      this.setState({ currentMonth: newMonth });
    } else {
      this.selectDate(newMonth);
    }
  };
  toggleShown = () => {
    this.props.setDateTimePickerIsShowing(!this.props.dateTimePickerIsShowing);
  };
  selectDate = (date, modifiers = {}) => {
    if (!modifiers.disabled) {
      this.onClick(moment(date));
      this.toggleShown();
    }
  };
  render() {
    const minDay = new Date();
    const maxDay = moment()
      .add(this.props.maxDays, 'days')
      .toDate();
    const selectedDate = this.props.selectedDate || moment();
    return (
      <CSSTransitionGroup
        className={styles.container}
        component="div"
        transitionEnterTimeout={400}
        transitionLeaveTimeout={400}
        transitionName={{
          enter: styles.enter,
          enterActive: styles.enterActive,
          leave: styles.leave,
          leaveActive: styles.leaveActive,
        }}
      >
        <MonthPicker
          onClick={this.toggleShown}
          isShown={this.props.dateTimePickerIsShowing}
          selectedDate={selectedDate}
          currentMonth={this.state.currentMonth}
          onMonthChange={this.onMonthChange}
          maxDays={this.props.maxDays}
          services={this.props.services}
          serviceSelected={this.props.serviceSelected}
          locations={this.props.locations}
          locationSelected={this.props.locationSelected}
          selectedLocation={this.props.locations?.find(
            location => location.Id === this.props.practiceId,
          )}
          selectedService={this.props.selectedService}
        />
        {this.props.dateTimePickerIsShowing ? (
          <div className={styles.datepickerContainer} key="1">
            <DayPicker
              month={this.state.currentMonth.toDate()}
              ref={this.datepicker}
              onDayClick={this.selectDate}
              selectedDays={this.props.selectedDate.toDate()}
              disabledDays={[
                {
                  before: minDay,
                  after: maxDay,
                },
              ]}
            />
          </div>
        ) : (
          <div className={styles.calendarContainer} key="2">
            <Calendar
              maxDays={this.props.maxDays}
              onClick={date => () => this.onClick(date)}
              selectedDate={this.props.selectedDate}
            />
            <TimeOfDayPicker
              currentFilter={this.props.currentFilter}
              morningDisabled={!this.props.hasMorningAppointments}
              afternoonDisabled={!this.props.hasAfternoonAppointments}
              eveningDisabled={!this.props.hasEveningAppointments}
              onMorningClick={this.props.filterMorning}
              onAfterNoonClick={this.props.filterAfternoon}
              onEveningClick={this.props.filterEvening}
            />
          </div>
        )}
      </CSSTransitionGroup>
    );
  }
}

const mapStateToProps = state => ({
  practiceId: state.practiceProfileReducer.profile.Id,
  selectedDate: moment(state.practiceAppointmentReducer.selectedDay),
  maxDays: state.practiceProfileReducer.profile.MaxDays || 0,
  services: state.practiceProfileReducer.profile.Services,
  locations: state.practiceProfileReducer.profile.AffiliatedOrganisations,
  currentFilter: state.practiceAppointmentReducer.currentFilter,
  hasMorningAppointments:
    state.practiceAppointmentReducer.days.first.hasMorningAppointments,
  hasAfternoonAppointments:
    state.practiceAppointmentReducer.days.first.hasAfternoonAppointments,
  hasEveningAppointments:
    state.practiceAppointmentReducer.days.first.hasEveningAppointments,
  dateTimePickerIsShowing:
    state.practiceBookingPageReducer.dateTimePickerIsShowing,
});

const mapDispatchToProps = dispatch => ({
  filterMorning: bindActionCreators(filterActions.filterMorning, dispatch),
  filterAfternoon: bindActionCreators(filterActions.filterAfternoon, dispatch),
  filterEvening: bindActionCreators(filterActions.filterEvening, dispatch),
  setDateTimePickerIsShowing: bindActionCreators(
    pageActions.setDateTimePickerIsShowing,
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(DatePicker);
export {
  styles,
  // for testing, can't rewire connect
  DatePicker,
};
